<template>
  <div>
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
        <a-input
            placeholder="请输入备注"
            v-decorator="[
          'mark',
          {rules: [{ required: true, message: '请输入备注!' }],initialValue:info.mark}
        ]"
        ></a-input>
      </a-form-item>

      <a-form-item :wrapper-col="{ span: 19, offset: 4 }" >
        <pxkeji-btn name="保存" type="primary" htmlType="submit" />
      </a-form-item>
    </a-form>
  </div>
</template>
<script>

export default {
  name: "info",
  props:{
    id:{
      type:Number,
      default:0
    }
  },
  data() {
    return {
      info:{},
      form:this.$form.createForm(this),
    };
  },
  components: {},
  mounted: function () {
    var that = this;
    this.$nextTick(function () {

      that.getInfoById();
    });

  },
  methods: {
    getInfoById:async function(){

      var res  = await this.$api.leads.getInfo({id:this.id});

      this.info = res.data;

    },
    handleSubmit:function(e){
      e.preventDefault();
      var that =this;
      this.form.validateFields((err, values) => {
        if (!err) {
          that.$api.leads.updateMark(values.mark,that.id).then(res =>{
            if (res.errorCode == this.$msg.responseCode.success) {
              this.$message.success(res.errorMsg);
              this.$emit("callbackMethod");
            } else {
              this.error(res.errorMsg);
            }
          })
        }
      });
    }
  },
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

